// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/engine-handling.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/engine-handling/engine-handling.js';

mount([g0]);
